import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const faqs = [{
    question: '¿Cuánto tarda en funcionar?',
    answer: 'Muchas chicas sienten cambios en los primeros días.'
  }, {
    question: '¿Es solo teoría?',
    answer: 'No, los ebooks vienen con ejercicios y espacios de practica.'
  }, {
    question: '¿Y si ya intenté de todo?',
    answer: 'Esto es distinto porque trabaja el apego emocional real Y desde el psicoanálisis.'
  }];
  return <section className="bg-gray-50 py-12 md:py-16 px-4" data-id="element-92">
      <div className="max-w-3xl mx-auto" data-id="element-93">
        <h2 className="text-3xl md:text-4xl font-black text-gray-900 mb-10 text-center" data-id="element-94">
          ❓ Preguntas frecuentes
        </h2>

        <div className="space-y-4" data-id="element-95">
          {faqs.map((faq, index) => <div key={index} className="bg-white rounded-lg shadow-md overflow-hidden" data-id="element-96">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-6 text-left hover:bg-gray-50 transition-colors" data-id="element-97">
                <span className="text-lg font-bold text-gray-900" data-id="element-98">
                  {faq.question}
                </span>
                {openIndex === index ? <ChevronUp className="w-6 h-6 text-purple-600 flex-shrink-0" data-id="element-99" /> : <ChevronDown className="w-6 h-6 text-purple-600 flex-shrink-0" data-id="element-100" />}
              </button>
              {openIndex === index && <div className="px-6 pb-6" data-id="element-101">
                  <p className="text-gray-700" data-id="element-102">{faq.answer}</p>
                </div>}
            </div>)}
        </div>
      </div>
    </section>;
}